<template>
  <v-main>
    <v-row>
      <v-col cols="8" offset=2>
        <v-card class="ml-4">
          <v-card-actions>
            <v-autocomplete label="Select account" class="ml-4" v-model="name" outlined hide-details :items="names" @change="new_account()"></v-autocomplete>
            <v-spacer></v-spacer>

            <template v-if="!isSimple">
              <v-checkbox class="ml-4" v-model="auto_open" label="Auto open games" />
              <v-btn class="ml-4" @click="open_ingame()">Open In Game</v-btn>
              <v-menu offset-y class="ml-4">
                <template  v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-4" dark v-bind="attrs" v-on="on">Filter</v-btn>
                </template>
                <v-list dense>
                  <v-list-item>
                    <v-checkbox label="OFC" v-model="showOFC"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-checkbox label="NLH" v-model="showNLH"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-checkbox label="PLO4" v-model="showPLO4"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-checkbox label="PLO5" v-model="showPLO5"></v-checkbox>
                  </v-list-item>
                  <v-list-item>
                    <v-checkbox label="PLO6" v-model="showPLO6"></v-checkbox>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-checkbox v-model="sortByType" class="ml-4 mr-4" label="Sort By Type"></v-checkbox>
            </template>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="poker-account" v-for="acc, idx in myAccounts" :key="idx + acc.status">
          <v-card round>
            <v-card-text>
              <div>
                <h3>
                  {{ acc.name }} - {{ acc.status }} ({{ acc.app || 'Pkr2' }})
                </h3>
                <h4>
                  <template v-if="club(acc.name)">
                    {{ club(acc.name).name || "Club ???" }} {{ club(acc.name).currency || "CHM?" }}
                  </template>
                  <template v-if="getAvailableBankroll(acc) !== null && getTotalBalance(acc) !== null">
                    {{ getAvailableBankroll(acc) }} / {{ getTotalBalance(acc)}} available
                  </template>
                  <template v-else-if="getAvailableBankroll(acc) !== null">
                    {{ getAvailableBankroll(acc)}} available
                  </template>
                  <template v-else-if="getTotalBalance(acc) !== null">
                    {{ getTotalBalance(acc)}} total
                  </template>
                  <template v-else>
                  </template>
                </h4>
              </div>

              <ul v-if="acc.status === 'in lobby'">
                <lobby-rooms :rooms="rooms(acc.name)" :acc="acc"></lobby-rooms>
              </ul>
              <ul v-if="acc.status === 'club list'">
                <template v-if="clubs(acc.name).length > 0">
                  <li v-for="club, idx in clubs(acc.name)" :key="idx">
                    {{ club.clubName }} ({{ club.displayClubID || club.clubID }})
                    <v-btn small @click="enter_club(acc.name, club.clubID)">enter</v-btn>
                  </li>
                </template>
                <template v-else>
                  <li>Account is not in any clubs.</li>
                </template>
              </ul>
              <div class="d-flex" v-if="acc.status === 'club list' && isDebug" style="border: solid darkred">
                <v-text-field class="pt-5 mr-2" v-model="applyClubCode" label="Club code to join (e.g. 9ogxk)"
                  clearable></v-text-field>
                <v-btn x-large @click="apply_to_club(acc.name, applyClubCode)"
                       :disabled="applyClubCode.length !== 5">
                  apply
                </v-btn>
              </div>

              <poker-table v-if="acc.status === 'in game'"
                :name="acc.name"
                @chat-message="sendChat">
              </poker-table>
              <p v-if="acc.status === 'in game'">
                <v-btn small color="accent" class="mr-4" @click="close(acc)">close</v-btn>
                Result: {{ result(acc.name) }}
              </p>
              <p v-else>
                <v-btn small color="primary" class="ml-4" v-if="acc.status === 'offline'" @click="login(acc)">login</v-btn>
                <v-btn small color="accent" class="ml-4" @click="close(acc)">close</v-btn>
                <v-btn small color="primary" class="ml-4" v-if="acc.status === 'in lobby'" @click="go_to_club_list(acc)">club list</v-btn>
                <v-btn small color="secondary" class="ml-4" @click="restart(acc.name)">restart</v-btn>
                <span v-if="isDebug" style="border: solid darkred">
                  <v-btn small color="secondary" class="ml-4" @click="_TEST_DC(acc.name)">TEST DC</v-btn>
                </span>
                <v-btn small color="secondary" class="ml-4" @click="logout(acc.name)">shutdown</v-btn>
              </p>
              <v-alert dense type="error" dismissible v-model="acc._error" class="my-warning" v-if="acc.error">
                {{ acc.error.msg}}: {{ acc.error.reason }}

              </v-alert>
              <v-alert dense type="warning" v-model="acc._warning" dismissible class="my-warning" v-if="acc.warning">
                {{ acc.warning.msg }}
              </v-alert>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
// import io from 'socket.io-client';
import bus from '../../bus';
import { mapGetters, mapState } from 'vuex';
import PokerTable from './PokerTable.vue';
import LobbyRooms from './LobbyRooms.vue';
import {getTime, roomType} from '@/plugins/helpers.js';

export default {
  components: {
    'poker-table': PokerTable,
    'lobby-rooms': LobbyRooms
  },
  data() {
    return {
      socket: null,
      name: null,
      accounts: [],
      games: {},
      // timer that gets club management accounts
      accInterval: null,
      messages: {},
      auto_open: false,
      showOFC: true,
      showNLH: true,
      showPLO4: true,
      showPLO5: true,
      showPLO6: true,
      sortByType: false,
      warning: false,
      error: false,

      loadedFromRoute: false,
      applyClubCode: '',
    };
  },
  mounted() {
    console.log("Poker page mounted!");
    this.$socket.emit("hello_pokerpage", {});

    this.$store.dispatch('subscribeTo', {channel: 'webapp-pokerpage'});
  },
  destroyed() {
    console.log("poker page destroyed!");
    this.$store.dispatch('unsubscribeFrom', {channel: 'webapp-pokerpage'});
  },
  computed: {
    myAccounts() {
      var filtered = [];
      for (let acc of this.accounts) {
        let typ = this.getType(acc);

        let status = this.onlineAccounts[acc.name].status;
        if (status !== 'in game') {
          filtered.push(acc)
          continue;
        }
        if (typ === 'ofc' && this.showOFC) {
          filtered.push(acc);
        } else if (typ === 'nlh' && this.showNLH) {
          filtered.push(acc);
        } else if (typ === 'plo4' && this.showPLO4) {
          filtered.push(acc);
        } else if (typ === 'plo5' && this.showPLO5) {
          filtered.push(acc);
        } else if (typ === 'plo6' && this.showPLO6) {
          filtered.push(acc);
        } else if (typ === '') {
          filtered.push(acc);
        }
      }
      if (this.sortByType) {
        filtered.sort((a, b) => {
          let typA = this.getType(a);
          let typB = this.getType(b);
          if (typA < typB) return -1;
          else if (typA > typB) return 1;
          return 0;
        })
      }
      return filtered;
    },
    names() {
      let names = [];
      for (let name in this.onlineAccounts) {
        if (this.isSimple) {
          if (!this.user.account_names) continue;
          if (!this.user.account_names.includes(name)) continue;
        }

        names.push(name);
      }
      names.sort((a, b) => {
        let a1 = a.toLowerCase();
        let b1 = b.toLowerCase();
        if (a1 < b1) return -1;
        if (a1 > b1) return 1;
        return 0;
      });
      return names;
    },
    ...mapGetters([
      'states', 'result', 'rooms', 'clubs',
      'clubmgmAccountByName', "isSimple", 'user',
      'isDebug', 'isDev'
    ]),
    ...mapState([
        'onlineAccounts',
    ]),
  },
  watch: {
    onlineAccounts() {
      if (this.$route.query.account && !this.loadedFromRoute) {
        if (!(this.$route.query.account in this.onlineAccounts)) return;
        this.name = this.$route.query.account;
        this.new_account();

        this.loadedFromRoute = true;
      }
    }
  },
  created() {
    bus.$on("join-challenge", this.join_challenge);
    bus.$on("standup", this.standup);
    bus.$on("stand-up-only", this.standUpOnly);
    bus.$on("leave-immediately", this.leaveImmediately);
    bus.$on("sitout", this.sitout);
    bus.$on("sitback", this.sitback);
    bus.$on("reload-chips", this.reloadChips);
    bus.$on("update-rebuys-total", this.updateRebuysTotal);
    bus.$on("sit-chips", this.sitChips);
    bus.$on("share-hand", this.shareHand);
    bus.$on("restart", this.restart);
    bus.$on("_TEST_DC", this._TEST_DC);
    bus.$on("logout", this.logout);
    bus.$on("register", this.register);
    bus.$on("unregister", this.unregister);
    bus.$on("tourney-rebuy", this.tourneyRebuy);
    bus.$on("tourney-addon", this.tourneyAddon);
  },
  sockets: {
    account() {
      this.handle_accounts();
    },
    accounts() {
      this.handle_accounts();
    },
    chat_msg(payload) {
      this.handle_chat_msg(payload)
    },
    _messages(data) {
      for (let msg of data.data) {
        for (let msg_name in msg) {
          let msg_data = msg[msg_name];

          let handler = this[`handle_${msg_name}`];
          if (handler) {
            this[`handle_${msg_name}`](msg_data);
          }
        }
      }
    },
  },
  methods: {
    handle_account() {
      setTimeout(() => {
        this.refreshAccounts();
      }, 500)
    },
    handle_accounts() {
      setTimeout(() => {
        this.refreshAccounts();
      }, 500)
    },
    handle_chat_msg(payload) {
      if (payload.type !== 'warning') {
        return;
      }

      let data = {
        'displayID': payload.displayID,
        'ts': getTime(new Date()),
        'msg': payload.data.text,
        'type': 'warning',
      };

      if (this.isDebugWarningMsg(data) && !this.isDev) return;

      let display_id = data.displayID;
      console.log("warning: ", data)
      for (var acc of this.accounts) {
        if (acc.name === display_id) {
          acc.warning = {
            msg: data.msg
          };
          acc._warning = true;
        }
      }
      this.$forceUpdate();
    },

    isDebugWarningMsg(message) {
      if (message.is_debug) {
        return true;
      }

      if (message.msg.indexOf("Error:") >= 0) {
        // some errors shouldn't be shown
        if (message.msg.indexOf("dummyForNotShowMessageOnUI") >= 0) {
          return true;
        }

        if (message.msg.indexOf("NOT_IN_ROOM") >= 0) {
          return true;
        }
      }

      if (message.msg.indexOf("(debug)") >= 0) {
        return true;
      }

      return false;
    },

    refreshAccounts() {
      for (let acc of this.accounts) {
        acc.app = this.onlineAccounts[acc.name].app;
        acc.status = this.onlineAccounts[acc.name].status;
        acc.available_bankroll = this.onlineAccounts[acc.name].available_bankroll;
      }
      if (this.auto_open) {
        this.open_ingame();
      }
      this.accounts = [...this.accounts];
    },
    getType(acc) {
      let st = this.states[acc.name];
      var settings = null;
      if (st && st.room && st.room.settings) {
        settings = st.room.settings;
      } else if (st && st.settings) {
        settings = st.settings;
      }
      if (!settings) {
        // console.log("no room or no room settings")
        return '';
      }
      if (settings.ofcType) {
        return 'ofc';
      }

      if (settings.allinOrFold) {
        return 'aof';
      }

      if (!settings.omaha) {
        return 'nlh';
      } else if (settings.omaha && settings._6Cards) {
        return 'plo6';
      } else if (settings.omaha && settings._5Cards) {
        return 'plo5';
      } else if (settings.omaha) {
        return 'plo4';
      }
      return '';
    },
    on_update() {
    },
    getOurSeat(state) {
      if (!state || !state.players) {
        return 0;
      }
      let name = state.displayID;
      for(var k in state.players) {
        let p = state.players[k];
        if (p.name === name) {
          return p.seat;
        }
      }
      return 0;
    },
    get_rooms(name) {
      return this.rooms[name];
    },
    get_clubs(name) {
      return this.clubs[name];
    },
    get_room_type(room) {
      return roomType(room.settings);
    },

    get_blinds(room) {
      let rs = room.settings;
      if ('live' in rs && rs.live) {
        return rs.startingChip;
      }
      var divider = 1.0;
      if (rs.withDecimal) {
        divider = 100.0;
      }
      return rs.bb / divider;
    },
    join_room(name, game_code) {
      this.$socket.emit("join_room", {'displayID': name, 'gameCode': game_code});
    },
    join_challenge(name) {
      this.$socket.emit("join_challenge", {'displayID': name});
    },
    enter_club(name, club_id) {
      this.$socket.emit("enter_club", {'displayID': name, 'clubID': club_id});
    },
    new_account() {
      this.add_table(this.name);
      this.$nextTick(() => {
        this.name = '';
      });
    },
    add_table(name) {
      let acc = {
        app: this.onlineAccounts[name].app,
        name: name,
        status: this.onlineAccounts[name].status,
        available_bankroll: this.onlineAccounts[name].available_bankroll || 0.0,
        error: null,
        warning: null,
        _error: false,
        _warning: false
      };
      this.accounts.push(acc);
    },
    close(acc) {
      for (var i = 0; i < this.accounts.length; i++) {
        if (this.accounts[i].name === acc.name) {
          this.accounts.splice(i, 1);
          return;
        }
      }
    },
    login(acc) {
      acc.status = 'connecting';
      this.$set(this.onlineAccounts, acc.name, acc);
      this.$socket.emit("login", {'displayID': acc.name});
    },
    go_to_club_list(acc) {
      this.$socket.emit("go_to_club_list", {'displayID': acc.name});
    },
    logout(name) {
      this.$socket.emit("logout", {'displayID': name});
    },
    restart(name) {
      this.$socket.emit("restart", {"displayID": name});
    },
    _TEST_DC(name) {
      this.$socket.emit("_TEST_DC", {"displayID": name});
    },
    open_ingame() {
      var open_names = [];
      this.accounts.forEach(acc => {
        open_names.push(acc.name);
      });
      // console.log(open_names);
      this.names.forEach(name => {
        // console.log(name)
        if (open_names.indexOf(name) > -1)  {
          return;
        }
        if (this.onlineAccounts[name].status === 'in game') {
          this.add_table(name);
        }
      });
    },

    // Event sent from chat panel
    sendChat(data) {
      let acc = data.acc;
      let text = data.text;
      this.$socket.emit("send_chat", {'displayID': acc.name, 'text': text});
      // console.log(data);
    },

    // events sent from player menu
    standup(name) {
      this._sendEvent("stand_up", name);
    },
    standUpOnly(name) {
      this._sendEvent("stand_up_only", name);
    },
    leaveImmediately(name) {
      this._sendEvent("leave_immediately", name);
    },
    sitout(name) {
      this._sendEvent("sitout", name);
    },
    sitback(name) {
      this._sendEvent("sitback", name);
    },
    sitChips(data) {
      console.log("sitChips", data);
      let name = data.name;
      if (!data.chips) return;
      let chips = parseInt(data.chips);
      if (chips <= 0) return;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id for sit", this.states, this.states[name]);
        return;
      }
      this.$socket.emit(
        'sit',
        {
          'displayID': name,
          'roomId': st.room_id,
          'buyinChips': chips,
        }
      );
    },
    shareHand(data) {
      console.log("share_hand", data);
      this.$socket.emit(
        'share_hand',
        {
          displayID: data.name,
          handSN: data.handSN,
          message: data.message,
        }
      );
    },
    reloadChips(data) {
      console.log("reload", data)
      let name = data.name;
      if (!data.chips) return;
      let chips = parseFloat(data.chips);
      let st = this.states[name];
      if (chips <= 0) return;
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }

      this.$socket.emit(
        'reload',
        {
          'displayID': name,
          'roomId': st.room_id,
          'chips': chips,
          'withDecimal': data.withDecimal,
        }
      );
    },
    updateRebuysTotal(data) {
      console.log("updateRebuysTotal", data)
      let name = data.name;
      let rebuysTotal = parseInt(data.rebuysTotal);
      this.$socket.emit(
        'update_rebuys_total',
        {
          'displayID': name,
          'gameCode': data.gameCode,
          'rebuysTotal': rebuysTotal,
        }
      );
    },
    register(data) {
      console.log("register", data);

      let name = data.name;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }

      this.$socket.emit(
        'register',
        {
          displayID: data.name,
          'roomId': st.room_id,
        }
      );
    },
    unregister(data) {
      console.log("unregister", data);

      let name = data.name;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }

      this.$socket.emit(
        'unregister',
        {
          displayID: data.name,
          'roomId': st.room_id,
        }
      );
    },

    tourneyRebuy(data) {
      console.log("tourneyRebuy", data);

      let name = data.name;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }

      this.$socket.emit(
        'tourney_rebuy',
        {
          displayID: data.name,
          'roomId': st.room_id,
        }
      );
    },
    tourneyAddon(data) {
      console.log("tourneyAddon", data);

      let name = data.name;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }

      this.$socket.emit(
        'tourney_addon',
        {
          displayID: data.name,
          'roomId': st.room_id,
        }
      );
    },

    _sendEvent(evt, name) {
      if (!this.$socket) return;
      let st = this.states[name];
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }
      console.log("sending event", evt, name);
      this.$socket.emit(evt, {'displayID': name, 'roomId': st.room_id})

    },
    club(name) {
      let clubmgmAcc = this.clubmgmAccountByName(name);

      if (!clubmgmAcc) {
        return null;
      }

      return clubmgmAcc.club || null;
    },
    getTotalBalance(acc) {
      // 'balance' includes coins on hold
      let name = acc.name;
      let balance = null;

      let club_acc = this.clubmgmAccountByName(name);
      console.log("clubmgm acct:", club_acc);

      if (club_acc && club_acc.bankroll_app) {
        // bankroll as the app reports it -- use this
        // it includes coins on hold
        balance = club_acc.bankroll_app;
        if (balance !== null && balance !== undefined) {
          return balance.toFixed(2);
        }
      }
      return null;
    },
    getAvailableBankroll(acc) {
      // 'available bankroll' is just what we can use now to buy in more
      let available_bankroll = acc.available_bankroll;
      if (available_bankroll === null || available_bankroll === undefined) {
        return null;
      }

      return available_bankroll.toFixed(2);
    },

    apply_to_club(name, club_code) {
      this.$socket.emit("apply_to_club", {'displayID': name, 'clubCode': club_code});
    },
  }
}
</script>

<style scoped>
.poker-account {
  width: 450px;
  float: left;
  margin: 0.2em;
}
.my-warning {
  display: flex;
  position: absolute;
  top: 220px;
  width: 420px;
}

</style>
